import {
    GET_UPC_TO_ITEMCODE_REQUEST,
    GET_UPC_TO_ITEMCODE_SUCCESS,
    GET_UPC_TO_ITEMCODE_ERROR,
  } from "../actions/types";
  
  export const upcToItemCode = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_UPC_TO_ITEMCODE_REQUEST:
        return {
          loading: true,
        };
      case GET_UPC_TO_ITEMCODE_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_UPC_TO_ITEMCODE_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  